export { SliderImage, type SliderImageProps } from './SliderImage';
